import { IDashboardItem } from '@ifit/gateway-wolf-dashboard-service';
import { DefaultImages } from '@ifit/img/out/defaults';
import CardMarketing from '@ifit/mp-card-marketing';

import { useDeviceType } from '../../state-management/selectors/use-device-type';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { getResizedImageUrl } from '../../util/get-resized-image-url';

interface IProps {
  item: IDashboardItem;
}

export function MarketingItem({ item }: IProps): JSX.Element {
  const { deepLink, description, id, imageUrl, leadline, title } = item;
  const clickHandler = getUserNavigationHandler(deepLink.url, ROWTITLES.MARKETING_ITEM);

  const deviceType = useDeviceType();
  const dimensions =
    deviceType === 'mobile'
      ? {
          width: 343,
          height: 280,
        }
      : {
          width: 711,
          height: 320,
        };

  const resizedImageUrl = getResizedImageUrl(imageUrl, DefaultImages.LargeCard, dimensions);

  return (
    <CardMarketing
      key={id}
      title={title}
      imageUrl={resizedImageUrl}
      onClick={clickHandler}
      description={description}
      leadLine={leadline}
    />
  );
}
